'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return function (parcelData) {
        return (0, _pipeWith2.default)(parcelData, (0, _update2.default)('meta', function (meta) {
            return meta || {};
        }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/updateMeta.js
// module id = 760
// module chunks = 35783957827783